import type { FinancialSectionV2SourceEnum, SalesTaxV2 } from "@credit-acceptance/step6-bff-client";

export type SalesTaxMessageKey =
  | "financial.salesTaxModal.messages.netOfTrade"
  | "financial.salesTaxModal.messages.netOfTradeAndRebate"
  | "financial.salesTaxModal.messages.netOfRebate";

/**
 * Picks the info message for the Sales Tax popup from the two state-rule flags.
 *
 * Both flags are CONTRACT-only, so a LIVE deal never shows a message; an unresolved
 * fork (absent `source`) is treated the same way rather than guessing at the rules.
 * An absent flag means "no message" — it is never read as a resolved `false`.
 * @param salesTax - The `salesTax` block of the itemization.
 * @param source - The `financial.source` fork, `undefined` when unresolved.
 * @returns {SalesTaxMessageKey | undefined} The message key, or `undefined` when neither flag applies.
 */
export function selectSalesTaxMessageKey(
  salesTax?: SalesTaxV2,
  source?: FinancialSectionV2SourceEnum
): SalesTaxMessageKey | undefined {
  if (source !== "CONTRACT") {
    return undefined;
  }
  const netOfTrade = salesTax?.netOfTrade === true;
  const netOfRebate = salesTax?.netOfRebate === true;
  if (netOfTrade && netOfRebate) {
    return "financial.salesTaxModal.messages.netOfTradeAndRebate";
  }
  if (netOfTrade) {
    return "financial.salesTaxModal.messages.netOfTrade";
  }
  return netOfRebate ? "financial.salesTaxModal.messages.netOfRebate" : undefined;
}
